import { useAssignAdmins } from '../../../hooks/users/useAssignAdmins.js';
import SearchBarSmall from '../../../components/searchBar/SearchBarSmall.jsx';
import SuccessModal from '../../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../../components/modales/ErrorModal.jsx';

export default function AssignAdmins() {
    const {
        admins,
        users,
        setSelectedUserId,
        searchUserTerm,
        searchAdminTerm,
        setSearchUserTerm,
        setSearchAdminTerm,
        addAdmin,
        removeAdmin,
        isAddDisabled,
        isRemoveDisabled,
        error,
        success,
        resetMessages
    } = useAssignAdmins();

    return (
        <>
            <div className='container mt-6'>
                <h1 className='text-center'>Gestionar los administradores del sitio</h1>
                <div className="row mt-5">
                    <div className="col-md-5">
                        <h5>Administradores</h5>
                        <select multiple className="form-select" size="15" onChange={e => setSelectedUserId(e.target.value)} required >
                            {admins.map(a => (
                                <option key={a.id} value={a.id}>{`${a.name} ${a.lastname}`}</option>
                            ))}
                        </select>
                        <SearchBarSmall searchTerm={searchAdminTerm} handleSearchChange={e => setSearchAdminTerm(e.target.value)} />
                    </div>
                    <div className="col-md-2 d-flex flex-column justify-content-center">
                        <button className="btn btn-primary mb-2 mt-2" onClick={addAdmin} disabled={isAddDisabled}><i className="bi bi-caret-left-fill"></i> Añadir</button>
                        <button className="btn btn-secondary mb-2" onClick={removeAdmin} disabled={isRemoveDisabled}><i className="bi bi-caret-right-fill"></i> Quitar</button>
                    </div>
                    <div className="col-md-5">
                        <h5>Usuarios</h5>
                        <select multiple className="form-select" size="15" onChange={(e) => setSelectedUserId(e.target.value)} required >
                            {users.map(u => (
                                <option key={u.id} value={u.id}>{`${u.name} ${u.lastname}`}</option>
                            ))}                          
                        </select>
                        <SearchBarSmall searchTerm={searchUserTerm} handleSearchChange={e => setSearchUserTerm(e.target.value)} />
                    </div>
                </div>
            </div>

            <SuccessModal
                show={!!success}
                message={success}
                onClose={resetMessages}
            />

            <ErrorModal
                show={!!error}
                message={error}
                onClose={resetMessages}
            />
        </>
    );
}